<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>

<div class="container">
<div class="row">
    <div class="col-12 col-md-12 p-3 p-md-5 text-center">
        <img src="assets/img/logo.png" alt="aplikasi absensi siswa murid sekolah"/><br/>    
    <img class="img-fluid rounded shadow" src="assets/img/aplikasi absensi siswa sekolah online .jpg" alt="aplikasi belajar e-learing online gratis"/><br/>
    <h3 class="text-left"><a href="https://axcoraschool.vercel.app">Aplikasi Absensi Sekolah</a></h3>
<p class="text-left">Ini adalah plugin package set setiap order paket website sekolah dari axcora school technology, dengan applikasi ini akan memudahkan proses monitoring ke disiplinan siswa murid dalam mengikuti kegiatan sekolah via absensi apps ini. </p>
<p class="text-left">
    Pelajari bagaimana aplikasi ini bekerja dalam proses absensi.
</p>  
<img class="img-fluid shadow rounded" src="assets/img/aplikasi sekolah absensi siswa (3).png" alt="aplikasi absensi sekolah online"/><br/>
<p class="text-left">Aplikasi ini memiliki fitur yang memudahkan petugas absensi dalam bekerja , dan berlaku untuk perkelas guna melaksanakan absensi apps ini, fitur yang tersedia : sekolah, kelas, area, siswa, staff absensi, konfigurasi system , start menjalankan absensi , laporan absensi detail.<br/>dan dalam bekerja melaksanakan absensi maka tinggal memilih kelas nantinya system akan menampilkan keseluruhan siswa, dan selanjutnya petugas absensi tinggal cek berdasarkan keterangan real untuk kebutuhan keterangan masuk , ijin , sakit dan lain lain.</p>
<img class="img-fluid shadow rounded" src="assets/img/aplikasi sekolah absensi siswa (4).png" alt="aplikasi absensi sekolah siswa murid gratis"/><br/>
<p class="text-left">Dan tersedia fitur laporan absensi guna monitoring kebutuhan untuk absensi siswa , applikasi ini sudah termasuk domain sch.id dan hosting serta pembuatan website sekolah, pilih paket website yang tersedia dengan fitur applikasi absensi ini untuk dapat menggunakan aplikasi absensi sekolah ini. <a href="https://www.youtube.com/watch?v=T8Xzb6VnWNE" target="_blank" class="text-danger">cek demo nya disini →</a>
</p>
<a routerLink="/website" class="btn btn-success rounded-pill btn-lg">Cek Paket website</a>
</div>


    </div></div>

  
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/erp" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
